export const routes = {
    auth: '/',
    contacts: '/contacts',
    main: '/main',
    test: '/test',
    results: '/results',
    materials: '/materials'
}